const getFormattedEnvironment = (env: string) => {
  return env.charAt(0).toUpperCase() + env.slice(1).toLowerCase();
};

export default getFormattedEnvironment;
